import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const rootCategorySchema = z.object({
  name: z.string().min(1, "Tên danh mục là bắt buộc"),
  description: z.string().min(1, "Mô tả là bắt buộc"),
  rootLanguageId: z.string().min(1, "Ngôn ngữ là bắt buộc"),
  color: z.string().optional(),
  isGreatCategory: z.boolean().optional(),
  isUpdateCategory: z.boolean().optional(),
  isListeningCategory: z.boolean().optional(),
  isJLPT: z.boolean().optional(),
  isKaiwa: z.boolean().optional(),
});

const CreateRootCategoryModal = ({
  show,
  handleClose,
  handleCreate,
  languages,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(rootCategorySchema),
  });

  const onSubmit = (data) => {
    handleCreate(data);
    handleClose();
    reset();
  };

  const handleCloseModal = () => {
    reset();
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Thêm mới danh mục gốc (JLPT, Kaiwa,...)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="rootCategoryName">
            <Form.Label>Tên danh mục</Form.Label>
            <Form.Control
              type="text"
              {...register("name")}
              isInvalid={!!errors.name}
            />
            {errors.name && (
              <Form.Control.Feedback type="invalid">
                {errors.name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="rootCategoryDescription">
            <Form.Label>Mô tả</Form.Label>
            <Form.Control
              type="text"
              {...register("description")}
              isInvalid={!!errors.description}
            />
            {errors.description && (
              <Form.Control.Feedback type="invalid">
                {errors.description.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="color">
            <Form.Label>Màu</Form.Label>
            <Form.Control
              type="text"
              {...register("color")}
              defaultValue="green"
              isInvalid={!!errors.color}
            />
            {errors.color && (
              <Form.Control.Feedback type="invalid">
                {errors.color.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group controlId="rootLanguageId">
            <Form.Label>Ngôn ngữ</Form.Label>
            <Form.Control
              as="select"
              {...register("rootLanguageId")}
              isInvalid={!!errors.rootLanguageId}
            >
              <option value="">Chọn ngôn ngữ</option>
              {languages.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </Form.Control>
            {errors.rootLanguageId && (
              <Form.Control.Feedback type="invalid">
                {errors.rootLanguageId.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Label>Tùy chọn menu</Form.Label>
          <Form.Check
            type="checkbox"
            {...register("isJLPT")}
            label="Khóa học JLPT"
          />
          <Form.Check
            type="checkbox"
            {...register("isKaiwa")}
            label="Khóa học Kaiwa"
          />
          <Form.Check
            type="checkbox"
            {...register("isGreatCategory")}
            label="Khóa học hay nhất"
            isInvalid={!!errors.isGreatCategory}
          />
          {errors.isGreatCategory && (
            <Form.Control.Feedback type="invalid">
              {errors.isGreatCategory.message}
            </Form.Control.Feedback>
          )}
          <Form.Check
            type="checkbox"
            {...register("isUpdateCategory")}
            label="Khóa học mới nhất"
          />
          <Form.Check
            type="checkbox"
            {...register("isListeningCategory")}
            label="Khóa học luyện thi"
          />
          <Modal.Footer style={{ marginTop: "5px" }}>
            <Button variant="secondary" onClick={handleCloseModal}>
              Đóng
            </Button>
            <Button variant="primary" type="submit">
              Thêm mới
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateRootCategoryModal;
